/**
 * The public partners' own address (partenaires.callizy.ca), served by the
 * same bundle as app.callizy.ca, like the console. On that host only the
 * partner space mounts: no client pages, no analytics, its own session.
 *
 * Locally, run Vite with VITE_HOTE_PARTENAIRES=partenaires.localhost and open
 * http://partenaires.localhost:5173.
 */
export const PARTNER_HOST: string = String(import.meta.env.VITE_HOTE_PARTENAIRES || 'partenaires.callizy.ca').toLowerCase()

export function isPartnerHost(host: string = window.location.hostname): boolean {
  return (host || '').toLowerCase() === PARTNER_HOST
}
